import React, { useEffect } from "react";
import * as Sentry from "@sentry/react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "src/api/firebase";
import { useAuth } from "src/context";
import { configureApiClient } from "@porchpass/api-client";

declare const __API_BASE_URL__: string;

export const AppInitializer = ({ children }: { children: React.ReactNode }) => {
  const { setUser } = useAuth();

  useEffect(() => {
    const unsubcribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      updateSentryUser(currentUser);

      // Configure the api-client when user is authenticated
      if (currentUser) {
        configureApiClient({
          baseUrl: __API_BASE_URL__,
          getAuthToken: async () => {
            const user = auth.currentUser;
            if (!user) {
              throw new Error("No authenticated user");
            }
            return user.getIdToken();
          },
        });
      }
    });

    return () => {
      unsubcribe();
    };
  }, []);

  const updateSentryUser = (user: typeof auth.currentUser | null) => {
    if (user) {
      Sentry.setUser({ id: user.uid });
    } else {
      Sentry.setUser(null);
    }
  };

  return <>{children}</>;
};
